export default "__VITE_ASSET__C88T2JOh__"